import api from './api';

const eiaService = {
  /**
   * List EIA certificates, optionally filtered by project.
   */
  async getCertificates(params = {}) {
    const response = await api.get('/eia/certificates', { params });
    return response.data;
  },

  /**
   * Get a single certificate with its conditions.
   */
  async getCertificateById(id) {
    const response = await api.get(`/eia/certificates/${id}`);
    return response.data;
  },

  /**
   * Register a new EIA certificate for a project.
   */
  async createCertificate(certificateData) {
    const response = await api.post('/eia/certificates', certificateData);
    return response.data;
  },

  /**
   * Update a certificate's status/dates.
   */
  async updateCertificate(id, certificateData) {
    const response = await api.patch(`/eia/certificates/${id}`, certificateData);
    return response.data;
  },

  /**
   * Add a condition to a certificate.
   */
  async createCondition(certificateId, conditionData) {
    const response = await api.post(`/eia/certificates/${certificateId}/conditions`, conditionData);
    return response.data;
  },

  /**
   * Update an EIA condition.
   */
  async updateCondition(id, conditionData) {
    const response = await api.patch(`/eia/conditions/${id}`, conditionData);
    return response.data;
  },

  /**
   * Delete an EIA condition.
   */
  async deleteCondition(id) {
    const response = await api.delete(`/eia/conditions/${id}`);
    return response.data;
  },

  /**
   * Generate recurring monitoring tasks for a condition across a date range.
   */
  async generateTasks(conditionId, { startDate, endDate }) {
    const response = await api.post(`/eia/conditions/${conditionId}/generate-tasks`, { startDate, endDate });
    return response.data;
  },
};

export default eiaService;
